import { logger, prettyPrint } from "./logger.mjs";
const logMetrics = {
  view: (data, pp = prettyPrint) => {
    pp("view", data);
  },
  click: (data, el, resolver, pp = prettyPrint) => {
    pp("click", data);
    if (resolver) resolver();
  },
  link: (data, pp = prettyPrint) => pp("link not implemented", data),
  event: (data, pp = prettyPrint) => pp("event not implemented", data)
};
const resolveMetrics = (logOverride, lm = logMetrics) => new Promise((resolve, reject) => {
  let metricsLib;
  if (!logOverride && typeof window !== "undefined") {
    metricsLib = window.metrics;
    if (metricsLib === void 0) {
      reject(new Error("Metrics is undefined"));
    }
    if (typeof metricsLib !== "object") {
      reject(new Error("Metrics is not an object"));
    }
  } else {
    metricsLib = lm;
  }
  resolve(metricsLib);
});
const shouldPreventDefault = (event, link) => {
  var _a;
  if (event && ((_a = event == null ? void 0 : event.target) == null ? void 0 : _a.href) && event.which === 1 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey && link) return true;
  return false;
};
const navigate = (link) => {
  window.location.href = link;
};
const metricsClick = (data, config, fnOverrides = {
  lg: logger,
  rm: resolveMetrics,
  spd: shouldPreventDefault,
  nv: navigate
}) => new Promise((resolve) => {
  const {
    lg,
    rm,
    spd,
    nv
  } = fnOverrides;
  const { logOverride, event, link } = config;
  const shouldPrevent = spd(event, link);
  const cb = () => {
    if (shouldPrevent && link) nv(link);
  };
  const timeout = setTimeout(() => {
    resolve(cb);
  }, 250);
  rm(!!logOverride).then((metrics) => {
    if (shouldPrevent) event == null ? void 0 : event.preventDefault();
    metrics == null ? void 0 : metrics.click(data, void 0, () => {
      clearTimeout(timeout);
      resolve(cb);
    });
  }).catch((err) => {
    lg.error("Metrics - 3P error - could not be resolved on click", err);
    resolve(cb);
  });
});
const metricsView = (data, logOverride, fnOverrides = { lg: logger, rm: resolveMetrics }) => new Promise((resolve) => {
  const { lg = logger, rm = resolveMetrics } = fnOverrides;
  rm(logOverride).then((metrics) => {
    metrics == null ? void 0 : metrics.view(data);
    resolve();
  }).catch((err) => {
    lg.error("Metrics - 3P error - could not be resolved on view", err);
    resolve();
  });
});
const metricsGetId = async (rm = resolveMetrics, lg = logger) => {
  var _a;
  lg.log("Metrics - get visitor ID", { message: "attempt" });
  let mcvId;
  try {
    const metrics = await rm(false);
    mcvId = await ((_a = metrics == null ? void 0 : metrics.getVisitorId) == null ? void 0 : _a.call(metrics));
  } catch (error) {
    lg.error("Metrics - 3P error - could not be resolved on getVisitorId", error);
  }
  lg.log("Metrics - get visitor ID", { success: !!mcvId });
  return mcvId;
};
export {
  logMetrics,
  metricsClick,
  metricsGetId,
  metricsView,
  resolveMetrics,
  shouldPreventDefault
};
//# sourceMappingURL=genericAnalytics.mjs.map
